import {
  ParameterCellRenderer,
  ParamValueCellRenderer,
  SeverityCellRenderer,
} from "../cell_renderers";
import { TABLE_INFO } from "../shared/table_config";

const { HEADER_LABEL: tableHeader, PROPS: tableProps } =
  TABLE_INFO.TOP_MISCONFIGURATIONS;

export const topMisconfigurationColumnDefs = [
  {
    headerName: tableHeader.NAME,
    field: tableProps.PARAMETER,
    flex: 3.4,
    cellRenderer: ParameterCellRenderer,
    filter: false,
    sortable: true,
    lockPosition: true,
    lockPinned: true,
  },
  {
    headerName: tableHeader.SEVERITY,
    field: tableProps.VULNERABILITY,
    flex: 1,
    cellRenderer: SeverityCellRenderer,
    filter: false,
    sortable: true,
  },
  {
    headerName: tableHeader.ASSETS,
    field: "count",
    flex: 1,
    cellRenderer: ParamValueCellRenderer,
    filter: false,
    sortable: true,
    
  },
];
